<template>
  <div class="World">
    <canvas id="canvas" ref="canvas" class="canvas" :class="{ show: ready }"/>  
    <div class="World__scroll">
      <div class="World__container"></div>     
    </div>
    <div class="World__overlay"/>
    <div class="World__black"/>
    <div class="World__trigger"/>
  </div>
</template>

<script>

import 'babylonjs-materials'
import 'babylonjs-loaders'

import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"
import MotionPathPlugin from "gsap/MotionPathPlugin"
import ScrollToPlugin from "gsap/ScrollToPlugin"

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin, ScrollToPlugin)

import { Engine, Scene, Color3, FreeCamera, Vector3, HemisphericLight, Mesh, SceneLoader, DirectionalLight, PointLight } from 'babylonjs'

export default {
  name: 'World',
  props: ['indice'],
  components: {},
  data: ()=>({
    ready: false,
    count: 0,
    cue: 0,
    hidden: true,
    overlay: false,
    step: 0,
    back: 2.50
  }),
  beforeDestroy() {
  
  },

  mounted: async function() {

    this.$cubes = ['Ambers_01', 'Ambers_02', 'Ambers_03', 'Ambers_04', 'Ambers_05', 'Ambers_06', 'Ambers_07', 'Ambers_08']

    const canvas = this.$refs.canvas
    const engine = new Engine(canvas, true, { preserveDrawingBuffer: true, stencil: true })
    const scene = new Scene(engine)
          scene.createDefaultCameraOrLight(false, true, true)
          scene.clearColor = new BABYLON.Color4(0, 0, 0, 0)

    engine.runRenderLoop(() => { scene.render() })
    engine.resize()

      const world = SceneLoader.Append("/static/", Settings.glb, scene, (mesh)=>{
      const cam = scene.activeCamera = mesh.cameras[1]

      console.log(mesh);
      console.log(cam);
      console.log(mesh.cameras);

      this.$mesh = mesh
      this.hideCubes()

      // 40.8333 //

      console.log('xxxx !');
    
      this.$anime = mesh.animationGroups.find(a => a.name === 'Camera_30_1080')
      this.$anicubes = mesh.animationGroups.find(a => a.name === 'Cubes_68_230')
      this.$door = mesh.meshes.find(a => a.id === 'SM_Pavillon_VIP_Door')
      this.$door.material.alpha = 1

      this.$gl = new BABYLON.GlowLayer("glow", scene, { mainTextureSamples: 40 })
      this.$gl.customEmissiveColorSelector = (mesh, subMesh, material, result) => {
        if(mesh.name == 'SM_Pavillon_VIP_Door') {
          let glow = 0
          if(this.cue < 18) glow = 0
          else if(this.cue > 21) glow = 1
          else glow = (this.cue-18)/3
          result.set(1, 1, 1, glow) 
        }
        else 
          result.set(0, 0, 0, 0) 
      }


      this.$anime.play()
      this.$anime.goToFrame(this.back)
      this.$anime.stop()

      window.requestAnimationFrame(this.onStep)


    })
    
    this.ready = true

    this.$nextTick(()=>{
      this.$scr = ScrollTrigger.create({
        trigger: ".World__container",
        start: "top top",
        end: "bottom 100%",
        scrub: 5,
        markers: true,
        onUpdate: (self)=>{
          this.cue = Settings.traveling_duration*self.progress.toFixed(3)
          this.$anime.play()
          this.$anime.goToFrame(this.cue)
          this.$anime.stop()
          this.$anicubes.play()
          this.$anicubes.goToFrame(this.cue)
          this.$anicubes.stop()

          if(this.hidden == false && this.cue < 3 ) {
            this.hidden = true
            this.hideCubes()
          }
          else if(this.hidden == true && this.cue > 3 && this.cue < 9 ) {
            this.hidden = false
            this.showCubes()
          }
          else if(this.hidden == false && this.cue > 9 ) {
            this.hidden = true
            this.hideCubes()
          }

          if(this.cue > 23 && this.cue < 29 && this.overlay == false && this.step != 2){
            this.step = 1
            this.overlay = true
            gsap.set('.World__overlay', { opacity: 1 })
          } 
          else if(this.cue > 29 && this.overlay == true){
            this.step = 2
            this.overlay = false
            gsap.to('.World__overlay', { opacity: 0, duration: .25 })
          } 
          else if(this.cue < 29 && this.cue > 23 && this.overlay == false && this.step == 2){
            this.step = 3
            this.overlay = true
            gsap.to('.World__overlay', { opacity: 1, duration: .25 })
          }
          else if(this.cue < 23 && this.overlay == true){
            this.step = 0
            this.overlay = false
            gsap.set('.World__overlay', { opacity: 0 })
          } 

          if(this.cue > 25 && this.cue < 28){
            const op = (this.cue-25)/3
            gsap.set('.World__black', { opacity: op })
          } 
          else if(this.cue > 28 && this.cue < 29){   
            const op1 = Math.abs(this.cue-29)
            gsap.set('.World__black', { opacity: op1 })
          } 

          console.log(this.cue);
        }
      })
    })

  },

  methods:{

    showCubes() {
      console.log('showCubes');
      _.each(this.$cubes, (id)=>{
        const cube = this.$mesh.meshes.find(a => a.id === id)
        gsap.set(cube, { visibility: 1 })
      })
    },

    hideCubes() {
      console.log('hideCubes');
      _.each(this.$cubes, (id)=>{
        const cube = this.$mesh.meshes.find(a => a.id === id)
        gsap.set(cube, { visibility: 0 })
      })
    },

    onStep() {

      // this.count += 1
      // this.count = 0

      this.back -= .01
      this.$anime.play()
      this.$anime.goToFrame(this.back)
      this.$anime.stop()

      if(this.back > 0)
        window.requestAnimationFrame(this.onStep)
}

  }

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.World
  position fixed
  top 0
  width 100vw
  height 100%
  overflow hidden  
 
  &.responsive 
    width 100%
    height 100%

  canvas
    width 100%
    height 100%
    opacity 0
    transition opacity .5s
    transition-delay 1

    &.show 
      opacity 1

  &__scroll
    position absolute
    top 0
    width 100vw
    height 100%
    overflow-y scroll
    overflow-x hidden

  &__container
     width 100%
     position relative
     container-height(2)

  &__overlay
    position absolute
    top 0
    left 0
    width 100vw
    height 100vh
    background white
    opacity 0

  &__black
    position absolute
    top 0
    left 0
    width 100vw
    height 100vh
    background black
    opacity 0

  &__trigger
    width 80vw
    height 5px
    z-index 200
    pointer-events none
    // border-bottom 1px solid red
    position absolute
    top 65vh

</style>























